export default __webpack_public_path__ + "static/unternehmen_bis-heute-540a26742a00a0375683d334bd69fda8.svg";